export default function PremiumRequiredHttpInterceptor($q, $injector) {
  'ngInject';

  let Authentication;
  let AccountService;

  return {
    responseError(rejection) {
      const { config } = rejection;

      if (config && config.ignoreGlobalErrorHandler) {
        return $q.reject(rejection);
      }

      Authentication = Authentication || $injector.get('Authentication');
      AccountService = AccountService || $injector.get('AccountService');

      if (rejection.status === 402) {
        Authentication.premiumExpired();

        if (Authentication.user.isManager) {
          AccountService.openPricingModal();
        }
      }

      return $q.reject(rejection);
    },
  };
}
